import { Component, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Icon } from '@shared/icon/icon';
import type { ModalWrapperDataInput } from '@appTypes';

@Component({
  selector: 'app-modal-wrapper',
  imports: [NgComponentOutlet, Icon],
  templateUrl: './modal-wrapper.html',
  styleUrls: ['./modal-wrapper.scss'],
})
export class ModalWrapper {
  protected readonly dialogRef = inject(DialogRef);
  protected readonly inputData = inject<ModalWrapperDataInput>(DIALOG_DATA);
}
